import DataGrid, {
    Column
} from 'devextreme-react/data-grid';
import PieChart from 'devextreme-react/pie-chart';
import Funnel from 'devextreme-react/funnel'
import DateBox from 'devextreme-react/date-box';
import moment from 'moment'
import 'antd/dist/antd.css';
import {
    Connector,
    Label,
    Chart,
    Series,
    ArgumentAxis,
    CommonSeriesSettings,
    Legend,
    Margin,
    Title,
    Subtitle,
    ValueAxis,
    Item,
    Border,
    Size,
    Tooltip,
    Grid,
} from 'devextreme-react/chart';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { studentProcessApi } from '../../api/studentProcess';
import PlaceHolder from '../../components/place-holder';
import styles from "./ProcessDashboard.module.css";
import { data1Info, data2Info, data3Source, data3Info, data4Source, data5Source } from './data';
import { showNotify } from '../../helpers/toast';
import { Col, Row } from 'antd';
import { formRegisterApi } from '../../api/formRegisterApi';
import ComboTuVanVien from '../../components/editor/cmd_tuvanvien';
import e from 'cors';
const customizeTooltip = (arg) => {
    return {
        text: `Số lượng ${arg.argumentText}: ${arg.valueText} - ${(arg.percent * 100).toFixed(2)}%`,
    };
}
function formatLabel(arg) {
    return `<span class="label">${arg.item.value}</span><br/>${arg.item.argument}`;
}

const ProcessDashboard = () => {

    const { dm_coso_id } = useSelector(x => x.coSo);
    const { nam_hoc } = useSelector((x) => x.namHoc);
    const [isLoading, setIsLoading] = useState(false);
    const [listCustomerRate, setListCustomerRate] = useState([]);
    const [listSourceRate, setListSourceRate] = useState([]);
    const [listLeadCampain, setListLeadCampain] = useState([]);
    const [listconversionRate, setListconversionRate] = useState([]);
    const [listOverDate, setListOverDate] = useState([]);
    const [tuvanvien_selected, set_tuvanvien_selected] = useState('');
    const [form_date, setFormDate] = useState({ fromDate: moment().startOf('year'), toDate: moment().toDate() });
    useEffect(() => {
        handleReloadData(dm_coso_id, nam_hoc, tuvanvien_selected, form_date)
    }, [dm_coso_id, nam_hoc, tuvanvien_selected, form_date])
    const handleReloadData = async (dm_coso_id, nam_hoc, tuvanvien_selected, form_date) => {
        try {
            setIsLoading(true)
            //form_date => đẩy dữ liệu từ ngày đền ngày
            var tuvanvien_id = tuvanvien_selected?tuvanvien_selected: 0;
            var formDate = form_date.fromDate?form_date.fromDate: new Date(moment().startOf('year'));
            var toDate = form_date.toDate?form_date.toDate: moment().toDate();
            console.log(formDate);
            console.log(toDate);
            const res = await formRegisterApi.ReportLead(dm_coso_id, tuvanvien_id, formDate, toDate);
            console.log(res);
            if (res.is_success) {
                const data = res.data
                //get API lấy data tỉ lệ chuyển đổi khách hàng
                setListCustomerRate(data.dataTyleChuyenDoiKhachHang)
                //get API lấy data tỉ lệ chuyển đổi theo nguồn
                setListSourceRate(data.dataTyleChuyenDoiNguon)
                //get API lấy data Lead by Campain
                setListLeadCampain(data.dataLeadByCampaign)
                //get API lấy data Tỉ lệ chuyển đổi
                setListconversionRate(data.dataTyleChuyenDoiNhanVien)
                //get API lấy data OverDate
                setListOverDate(data5Source)
                setIsLoading(false);
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    }

    const listLeadCampainDate = React.useMemo(() => {
        const _list = listLeadCampain.reduce((prev, curr, index) => {
            const data = curr.data;
            data.forEach((val) => {
                if (!prev[val.month]) {
                    prev[val.month.toString()] = { [(index + 1).toString()]: val.so_luong }
                } else {
                    prev[val.month.toString()] = {
                        ...prev[val.month.toString()],
                        [(index + 1).toString()]: val.so_luong
                    };
                }
            })
            return prev;
        }, {})
        return Object.keys(_list).map((val) => {
            return {
                month: 'Tháng ' + val.toString(),
                ..._list[val],
            }
        })
    }, [listLeadCampain])
    const listconversionRateDate = React.useMemo(() => {
        const _list = listconversionRate.reduce((prev, curr) => {
            const data = curr.data;
            data.forEach((val) => {
                if (!prev[val.staff]) {
                    prev[val.staff.toString()] = { [curr.value]: val.so_luong }
                } else {
                    prev[val.staff.toString()] = {
                        ...prev[val.staff.toString()],
                        [curr.value]: val.so_luong
                    };
                }
            })
            return prev;
        }, {})
        return Object.keys(_list).map((val) => {
            return {
                staff: val.toString(),
                ..._list[val],
            }
        })
    }, [listconversionRate])
    return (
        <div style={{ width: '98%', height: '95%', marginBottom: 20, marginTop: 20 }}>
            <Row gutter={16} style={{ marginTop: 20, marginBottom: 40 }}>
                <Col xl={7} >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <label style={{ fontWeight: "bold", marginRight: 5, width: 120 }}>Tư vấn viên</label>
                        <ComboTuVanVien
                            value={tuvanvien_selected}
                            dm_coso_id={dm_coso_id}
                            showClearButton={true}
                            onValueChanged={(data) => {
                                set_tuvanvien_selected(data);
                            }}
                        />
                    </div>
                </Col>
                <Col xl={6} >
                    <div style={{ display: "flex", alignItems: "center", marginLeft: 40 }}>
                        <label style={{ fontWeight: "bold", marginRight: 5, width: 120 }}>Từ ngày</label>
                        <DateBox
                            value={form_date.fromDate}
                            stylingMode="outlined"
                            displayFormat="dd/MM/yyyy"
                            onValueChanged={(e) => {
                                if (e.event)
                                    setFormDate(
                                        Object.assign({}, form_date, {
                                            fromDate: moment(e.value).toDate(),
                                        })
                                    );
                            }}
                        />
                    </div>
                </Col>
                <Col xl={6} >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <label style={{ fontWeight: "bold", marginRight: 5, width: 120 }}>Đến ngày</label>
                        <DateBox
                            value={form_date.toDate}
                            stylingMode="outlined"
                            displayFormat="dd/MM/yyyy"
                            onValueChanged={(e) => {
                                console.log(e.value)
                                if (e.event)
                                    setFormDate(
                                        Object.assign({}, form_date, {
                                            toDate: moment(e.value).toDate(),
                                        })
                                    );

                            }}
                        />
                    </div>
                </Col>
            </Row>

            {isLoading && <PlaceHolder line_number={10} />}
            {!isLoading &&
                <div >
                    <Row gutter={16}>
                        <Col xl={8} >
                            <Funnel id="chart"
                                dataSource={listCustomerRate}
                                palette="Soft Pastel"
                                argumentField="name"
                                valueField="so_luong"
                            // customizePoint={(e) => {
                            //     return { color: `${e.data.color}` }
                            // }}
                            // height={400}
                            // width={450}
                            >
                                <Size width={400} height={350} />
                                <Title text="Tỉ lệ chuyển đổi khách hàng">
                                </Title>
                                <Tooltip enabled={true} format="fixedPoint" />
                                <Label
                                    visible={true}
                                    position="inside"
                                    backgroundColor="none"
                                    customizeText={formatLabel}
                                />
                            </Funnel>

                        </Col>
                        <Col xl={8}>
                            <PieChart
                                id="chart"
                                // type="doughnut"
                                title="Tỉ lệ chuyển đổi theo nguồn"
                                palette="Soft Pastel"
                                dataSource={listSourceRate}
                            // customizePoint={(e) => {
                            //     return { color: `${e.data.color}` }
                            // }}
                            // height={400}
                            // width={500}
                            >
                                <Size width={400} height={350} />
                                <Series argumentField="name" valueField={"so_luong"}>
                                    <Label visible={true} position="inside">
                                        <Connector visible={true} />
                                    </Label>
                                </Series>
                                <Legend
                                    margin={10}
                                    horizontalAlignment="center"
                                    verticalAlignment="bottom"
                                />

                                <Tooltip enabled={true} customizeTooltip={customizeTooltip}>
                                </Tooltip>
                            </PieChart>
                        </Col>
                        <Col xl={8}>
                            <Chart id="chart" dataSource={listOverDate} >
                                <Size width={400} height={350} />
                                <Legend
                                    verticalAlignment="bottom"
                                    horizontalAlignment="center"
                                    itemTextPosition="right"
                                />
                                <Series
                                    valueField="so_luong"
                                    argumentField="name"
                                    name="Số lượng status overdate"
                                    type="bar"
                                    color="#ba4618" />
                            </Chart>

                        </Col>
                        <Col xl={8}>
                            <Chart
                                id="chart"
                                title="Tỉ lệ chuyển đổi"
                                dataSource={listconversionRateDate}
                                rotated
                            // height={300}
                            // width={350}
                            >
                                <Size width={400} height={350} />
                                <CommonSeriesSettings argumentField="staff" type="stackedBar" />
                                {listconversionRate.map((value) => <Series
                                    // color={value.color}
                                    valueField={value.value}
                                    name={value.name}
                                />)}


                                <Legend
                                    verticalAlignment="right"
                                    horizontalAlignment="center"
                                    itemTextPosition="top"
                                />

                                <Tooltip
                                    enabled={true}
                                    location="edge"
                                    customizeTooltip={customizeTooltip}
                                />
                            </Chart>
                        </Col>
                        <Col xl={16}>
                            <Chart
                                id="chart"
                                palette="Violet"
                                dataSource={listLeadCampainDate}
                            // height={300}
                            // width={500}
                            // customizePoint={(e) => {
                            //     return { color: `${e.data.color}` }
                            // }}
                            >
                                <Size width={800} height={350} />
                                <CommonSeriesSettings
                                    argumentField="month"
                                    type={'line'}
                                />
                                {
                                    listLeadCampain.map((item, index) => <Series
                                        // color={item.color}
                                        key={(index + 1).toString()}
                                        valueField={(index + 1).toString()}
                                        name={item.ten_chien_dich} />)
                                }
                                <ArgumentAxis
                                    valueMarginsEnabled={false}
                                    discreteAxisDivisionMode="crossLabels"
                                >
                                    <Grid visible={true} />
                                </ArgumentAxis>
                                <Legend
                                    verticalAlignment="bottom"
                                    horizontalAlignment="center"
                                    itemTextPosition="right"
                                />
                                <Title text="Lead by campain">
                                </Title>
                                <Tooltip enabled={true} />
                            </Chart>
                        </Col>
                    </Row>


                </div>

            }
            {/* <DataGrid
                keyExpr="id"
                dataSource={studentProcesses}
                columnHidingEnabled={true}
                columnAutoWidth={true}
                showBorders={true}
                showColumnLines={false}
                showRowLines={false}
                rowAlternationEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={'nextColumn'}
                hoverStateEnabled={true}
                focusedRowEnabled={true}
                height={window.innerHeight - 400 - 100}
            >

                <Column dataField={"name"} />
                <Column dataField={"so_luong"} caption={"Số lượng"} />
                <Column dataField={"description"} caption={"Mô tả"} />

            </DataGrid> */}
        </div>
    );
};

export default ProcessDashboard;